module.exports = __webpack_public_path__ + "img/page-not-found.99e57afc.webp";